export default {
    name: 'EventKasse',
    import: function () { return import('./index'); },
};
